export default __webpack_public_path__ + "static/media/Sarah-Gruber.afc15e26.png";